export * from '@primeuix/themes/material/colorpicker';
export { default } from '@primeuix/themes/material/colorpicker';
